import SearchTrainByRoute from './SearchTrainByRoute';

export default SearchTrainByRoute;
